<div class="sl-tp-controls">
	<div class="sl-tp-grid">
		@if (stopLossForm) {
			<div
				class="sl-tp-side"
				[formGroup]="stopLossForm"
			>
				<label
					class="sl-tp-header"
					[class.label-inactive]="allowToggle() && !stopLossForm.get('isActive')?.value"
					[class.label-disabled]="!allowToggle()"
				>
					@if (allowToggle()) {
						<input
							size="s"
							tuiCheckbox
							type="checkbox"
							formControlName="isActive"
							(change)="toggleActiveSlTp('stop-loss')"
						/>
					}
					<span
						class="sl-tp-title"
						tuiTitle
					>
						{{ 'slTp.stopLoss' | translate }}
					</span>
				</label>

				<div
					class="sl-tp-inputs"
					formGroupName="values"
				>
					<tui-textfield
						iconStart="@tui.percent"
						class="sl-tp-input"
						[tuiTextfieldCleaner]="false"
						tuiTextfieldSize="s"
					>
						<input
							tuiInputNumber
							inputNumberSigns
							[min]="slTpBounds()?.stopLoss?.min?.percent ?? null"
							[max]="slTpBounds()?.stopLoss?.max?.percent ?? null"
							[step]="1"
							[formControlName]="slTpValuesEnum.PERCENT"
							[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
							[prefix]="getSlTpValues('stop-loss', slTpValuesEnum.PERCENT) > 0 ? '+' : ''"
							(input)="putCursorEnd($event.target)"
						/>
					</tui-textfield>

					<tui-textfield
						iconStart="@tui.dollar-sign"
						class="sl-tp-input"
						[tuiTextfieldCleaner]="false"
						tuiTextfieldSize="s"
					>
						<input
							tuiInputNumber
							inputNumberSigns
							[min]="slTpBounds()?.stopLoss?.min?.price ?? null"
							[max]="slTpBounds()?.stopLoss?.max?.price ?? null"
							[step]="1"
							[formControlName]="slTpValuesEnum.PRICE"
							[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
							(input)="putCursorEnd($event.target)"
						/>
					</tui-textfield>

					<tui-textfield
						iconStart="@tui.arrow-up-down"
						class="sl-tp-input"
						[tuiTextfieldCleaner]="false"
						tuiTextfieldSize="s"
					>
						<input
							tuiInputNumber
							inputNumberSigns
							[min]="slTpBounds()?.stopLoss?.min?.dollar ?? null"
							[max]="slTpBounds()?.stopLoss?.max?.dollar ?? null"
							[step]="1"
							[formControlName]="slTpValuesEnum.DOLLAR"
							[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
							[prefix]="getSlTpValues('stop-loss', slTpValuesEnum.DOLLAR) > 0 ? '+' : ''"
							(input)="putCursorEnd($event.target)"
						/>
					</tui-textfield>
				</div>
			</div>
		}

		@if (takeProfitForm) {
			<div
				class="sl-tp-side"
				[formGroup]="takeProfitForm"
			>
				<label
					class="sl-tp-header"
					[class.label-inactive]="allowToggle() && !takeProfitForm.get('isActive')?.value"
					[class.label-disabled]="!allowToggle()"
				>
					@if (allowToggle()) {
						<input
							size="s"
							tuiCheckbox
							type="checkbox"
							formControlName="isActive"
							(change)="toggleActiveSlTp('take-profit')"
						/>
					}
					<span
						class="sl-tp-title"
						tuiTitle
					>
						{{ 'slTp.takeProfit' | translate }}
					</span>
				</label>

				<div
					class="sl-tp-inputs"
					formGroupName="values"
				>
					<tui-textfield
						iconStart="@tui.percent"
						class="sl-tp-input"
						[tuiTextfieldCleaner]="false"
						tuiTextfieldSize="s"
					>
						<input
							tuiInputNumber
							inputNumberSigns
							[min]="slTpBounds()?.takeProfit?.min?.percent ?? null"
							[max]="slTpBounds()?.takeProfit?.max?.percent ?? null"
							[step]="1"
							[formControlName]="slTpValuesEnum.PERCENT"
							[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
							[prefix]="getSlTpValues('take-profit', slTpValuesEnum.PERCENT) > 0 ? '+' : ''"
							(input)="putCursorEnd($event.target)"
						/>
					</tui-textfield>

					<tui-textfield
						iconStart="@tui.dollar-sign"
						class="sl-tp-input"
						[tuiTextfieldCleaner]="false"
						tuiTextfieldSize="s"
					>
						<input
							tuiInputNumber
							inputNumberSigns
							[min]="slTpBounds()?.takeProfit?.min?.price ?? null"
							[max]="slTpBounds()?.takeProfit?.max?.price ?? null"
							[step]="1"
							[formControlName]="slTpValuesEnum.PRICE"
							[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
							(input)="putCursorEnd($event.target)"
						/>
					</tui-textfield>

					<tui-textfield
						iconStart="@tui.arrow-up-down"
						class="sl-tp-input"
						[tuiTextfieldCleaner]="false"
						tuiTextfieldSize="s"
					>
						<input
							tuiInputNumber
							inputNumberSigns
							[min]="slTpBounds()?.takeProfit?.min?.dollar ?? null"
							[max]="slTpBounds()?.takeProfit?.max?.dollar ?? null"
							[step]="1"
							[formControlName]="slTpValuesEnum.DOLLAR"
							[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ' }"
							[prefix]="getSlTpValues('take-profit', slTpValuesEnum.DOLLAR) > 0 ? '+' : ''"
							(input)="putCursorEnd($event.target)"
						/>
					</tui-textfield>
				</div>
			</div>
		}
	</div>
</div>
